const data = [
  {
    id: 0,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Fire',
    span: 'Fire',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-fire-2.svg',
  },
  {
    id: 1,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Water',
    span: 'Water',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-water-2.svg',
  },
  {
    id: 2,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Earth',
    span: 'Earth',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-earth-2.svg',
  },
  {
    id: 3,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Life',
    span: 'Life',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-life-2.svg',
  },
  {
    id: 4,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Death',
    span: 'Death',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-death-2.svg',
  },
  {
    id: 5,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Dragon',
    span: 'Dragon',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-dragon-2.svg',
  },
  {
    id: 6,
    filterType: 'element',
    class: 'more',
    selected: false,
    filter: 'Neutral',
    span: 'Neutral',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-element-neutral-2.svg',
  },
  {
    id: 7,
    filterType: 'rarity',
    class: 'more',
    selected: false,
    filter: 'Common',
    span: 'Common',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-rarity-common.svg',
  },
  {
    id: 8,
    filterType: 'rarity',
    class: 'more',
    selected: false,
    filter: 'Rare',
    span: 'Rare',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-rarity-rare.svg',
  },
  {
    id: 9,
    filterType: 'rarity',
    class: 'more',
    selected: false,
    filter: 'Epic',
    span: 'Epic',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-rarity-epic.svg',
  },
  {
    id: 10,
    filterType: 'rarity',
    class: 'more',
    selected: false,
    filter: 'Legendary',
    span: 'Legendary',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-rarity-legendary.svg',
  },
  {
    id: 11,
    filterType: 'type',
    class: 'more',
    selected: false,
    filter: 'Monster',
    span: 'Monster',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-type-monster.svg',
  },
  {
    id: 12,
    filterType: 'type',
    class: 'more',
    selected: false,
    filter: 'Summoner',
    span: 'Summoner',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-type-summoner.svg',
  },
  {
    id: 13,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'alpha',
    span: 'Alpha',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-alpha.svg',
  },
  {
    id: 14,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'beta',
    span: 'Beta',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-beta.svg',
  },
  {
    id: 15,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'promo',
    span: 'Promo',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg',
  },
  {
    id: 16,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'reward',
    span: 'Reward',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg',
  },
  {
    id: 17,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'untamed',
    span: 'Untamed',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-untamed.svg',
  },
  {
    id: 18,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'dice',
    span: 'Dice',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-dice.svg',
  },
  {
    id: 19,
    filterType: 'edition',
    class: 'more',
    selected: false,
    filter: 'chaos',
    span: 'Chaos',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-dice.svg',
  },
];

export {data}